import AsyncAutocomplete from '@components/v2/form/AsyncAutocomplete/AsyncAutocomplete';
import LangEnum from '../../../../../../lang/LangEnum';
import {
  ClassificationType,
  ClassificationTypeEntityEnum,
} from '../../../../../classifications/classification.types';
import { useTranslation } from '../../../../../translation/TranslationContext';
import { RelatedProductsSectionGeneralSettingsProps } from '../../../types/GeneralSettings.types';

interface RelatedProductsSectionAutocompleteProps
  extends RelatedProductsSectionGeneralSettingsProps {}

const RelatedProductsSectionAutocomplete = ({
  handleChangeAndBlur,
  generalSettings,
}: RelatedProductsSectionAutocompleteProps) => {
  const { translate } = useTranslation();

  const selected = generalSettings.suggestedClassificationType ?? null;

  return (
    <AsyncAutocomplete<ClassificationType>
      label={translate(LangEnum.GLOBAL_CLASSIFICATION)}
      placeholder={LangEnum.GLOBAL_CLASSIFICATION}
      value={selected?.id ?? null}
      initialData={selected ? [selected] : undefined}
      source={{
        url: 'classification-types',
        queryField: 'query',
        order: { name: 'ASC' },
        defaultQuery: { entity: ClassificationTypeEntityEnum.PRODUCT_COLOR },
        eager: true,
      }}
      getOptionLabel={(classification) => classification.name}
      onChange={(_, options) =>
        handleChangeAndBlur({
          value: options[0] ?? null,
          name: 'suggestedClassificationType',
        })
      }
    />
  );
};

export default RelatedProductsSectionAutocomplete;
